import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronRight, Star } from 'lucide-react';

export default function TrialPopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show popup after 3 seconds
    const timer = setTimeout(() => {
      // Check if user has dismissed the popup before
      const hasSeenPopup = localStorage.getItem('hasSeenTrialPopup');
      if (!hasSeenPopup) {
        setIsOpen(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    // Store that user has seen the popup
    localStorage.setItem('hasSeenTrialPopup', 'true');
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed bottom-4 right-4 z-50 max-w-sm"
        >
          <div className="relative bg-black rounded-2xl overflow-hidden border border-white/10">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: [0.3, 0.6, 0.3] }}
              transition={{ duration: 2, repeat: Infinity }}
              className="absolute -inset-2 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-3xl blur-lg -z-10"
            />
            
            <button
              onClick={handleClose}
              className="absolute top-2 right-2 p-2 rounded-full hover:bg-white/10 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="p-6">
              <motion.div
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5, repeat: Infinity, repeatType: "reverse" }}
                className="inline-block mb-4"
              >
                <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-1 rounded-full shadow-lg shadow-blue-500/20">
                  <div className="bg-black px-4 py-1 rounded-full flex items-center space-x-2">
                    <Star className="w-4 h-4 text-blue-400" />
                    <span className="text-sm font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                      PREMIUM MEMBERSHIP
                    </span>
                    <Star className="w-4 h-4 text-blue-400" />
                  </div>
                </div>
              </motion.div>

              <h3 className="text-2xl font-bold mb-2">Join Today</h3>
              <p className="text-gray-400 mb-4">Experience Auckland's premier fitness destination.</p>

              <a
                href="/memberships"
                className="flex items-center justify-center space-x-2 w-full bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-3 rounded-full font-bold hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 group"
                onClick={handleClose}
              >
                <span>VIEW MEMBERSHIPS</span>
                <ChevronRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}